import useQuery from "hooks/useQuery";
import queryString from "query-string";
import { useEffect } from "react";
import { getSecciones } from "routes/filialesEditar/api";
import { showErrorModal } from "utils";

const useGetSecciones = (filterBy, acuerdoTipoId) => {
  const { refetch, data, loading } = useQuery({
    autoFetch: false,
    queryFn: getSecciones,
    onError: err => showErrorModal({ err })
  });

  useEffect(() => {
    if (filterBy === "secciones") return;
    fetch();
  }, [acuerdoTipoId]);

  const fetch = (articuloId) => {
    const query = queryString.stringify({
      filterBy,
      articuloId,
      acuerdoTipoId,
    });

    refetch(query);
  };

  const ordenSeccionesPersonalizado = [
    "ENVIOS POR DISTANCIA",
    "LISTADO ART. ESPECIFICOS",
    "ENVIOS DE PALLETS",
    "BOLSAS PACKS CREDIFIN",
    "VENTA Y ENVIOS PREPAGOS",
    "BOLSINES COMERCIALES"
  ];

  const secciones = data?.data?.secciones?.slice().sort((a, b) => {
    const nombreA = a.nombre.trim().toUpperCase();
    const nombreB = b.nombre.trim().toUpperCase();
    return ordenSeccionesPersonalizado.indexOf(nombreA) - ordenSeccionesPersonalizado.indexOf(nombreB);
  });

  const seccionesOptions = secciones?.map(seccion => ({
    key: seccion.id,
    value: seccion.id,
    label: seccion.nombre.trim()
  }));

  return {
    secciones,
    seccionesOptions,
    loading,
    fetch,
  }
};

export default useGetSecciones;